/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Text from '../text';
import { colors, sizes } from 'ui/constants';

import s from './styles.module.scss';

const FieldControl = ({
  label = null,
  labelStyle = null,
  hint = null,
  inputComponent,
  innerComponentStyle = null,
  style = null,
  className = null,
  inputClassName = null,
  error = null,
  errorColor = null,
  itemKey,
  ...props
}) => {
  const { t } = useTranslation();

  props = {
    ...props,
    id: typeof props.id === 'undefined' ? null : props.id,
  };

  const FormInputField = inputComponent;
  return (
    <div className={cx(className, s.fieldControl)}>
      {label && (
        <Text size={Text.size.xs} className={s.fieldControlLabel} style={labelStyle} weight={Text.weight.regular}>
          {label}
        </Text>
      )}
      {hint && (
        <Text size={Text.size.xs} className={s.fieldControlHint}>
          {hint}
        </Text>
      )}
      <FormInputField
        key={itemKey}
        innerComponentStyle={innerComponentStyle}
        errorColor={errorColor}
        error={error}
        {...props}
        className={inputClassName}
      />
      {error && (
        <Text
          size={Text.size.xs}
          style={{
            marginTop: sizes.base / 2,
            ...(FormInputField.type ? FormInputField.type.style.errorText : { color: colors.error }),
            ...(errorColor && { color: errorColor }),
          }}
        >
          {t(error)}
        </Text>
      )}
    </div>
  );
};

FieldControl.propTypes = {
  id: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  labelStyle: PropTypes.shape({}),
  innerComponentStyle: PropTypes.shape({}),
  itemKey: PropTypes.string.isRequired,
  inputComponent: PropTypes.func.isRequired,
  error: PropTypes.string,
  errorColor: PropTypes.string,
};

export default FieldControl;
